const updateEquipmentModels = {
  toastr: 'Upgraded Model Equipment',
  toastr1: 'has been updated successfully',
  toastrError: 'Name already registered',
  toastrError1: 'Enter another name'
};

export default updateEquipmentModels;
